import { render, staticRenderFns } from "./DataCapture.vue?vue&type=template&id=1fb40396&"
import script from "./DataCapture.vue?vue&type=script&lang=ts&"
export * from "./DataCapture.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/circleci/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1fb40396')) {
      api.createRecord('1fb40396', component.options)
    } else {
      api.reload('1fb40396', component.options)
    }
    module.hot.accept("./DataCapture.vue?vue&type=template&id=1fb40396&", function () {
      api.rerender('1fb40396', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/data-entry/inputs/DataCapture.vue"
export default component.exports